import React from 'react'

import Modal from 'components/Modal'

class ModalButton extends React.Component {
  state = {
    showModal: false,
  }

  render() {
    return (
      <React.Fragment>
        {this.props.renderButton({
          onClick: () => this.setState({ showModal: true }),
        })}
        <Modal
          title={this.props.title}
          loading={this.props.loading}
          small={this.props.small}
          isOpen={this.state.showModal}
          onRequestClose={() => this.setState({ showModal: false })}>
          {this.props.renderModal({
            closeModal: () => this.setState({ showModal: false }),
          })}
        </Modal>
      </React.Fragment>
    )
  }
}

export default ModalButton



// WEBPACK FOOTER //
// ./src/components/ModalButton.js